import React from 'react';
import Row from '@amzn/meridian/row';
import Text from '@amzn/meridian/text';
import SortableList from './sortableRegionTaskList';
import { COLUMNS, ROW_LAYOUT } from '../constants';

const FormTasksTable = () => {
  return (
    <div>
      <Row widths={ROW_LAYOUT} width="100%">
        {COLUMNS.map(({ name }) => (
          <Text key={name} role="columnheader" className="form-tasks-table__text">
            {name}
          </Text>
        ))}
      </Row>
      <SortableList />
    </div>
  );
};

export default FormTasksTable;
